export default __webpack_public_path__ + "static/media/365.eae24367.jpg";